import {profile} from 'constants/url';
import useUpdate from 'components/hooks/useUpdate';
import {EditingOptions} from 'components/grid-dx/types';

function useUpdateProfile() {
  const updateProfile = useUpdate(profile);
  return (editingOptions: EditingOptions) => updateProfile(editingOptions);
}

export default useUpdateProfile;
